import axios from 'axios'
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = 'https://api.coolbrainscience.cn/release'
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'https://api.coolbrainscience.cn/release'
}

export async function get(url, params) {
  try {
    let res = await axios.get(url, {
      params: params,
    });
    return new Promise((resolve) => {
      if (res.code === "SUCCESS") {
        resolve(res.data);
      } else {
        console.log("请求结果");
        resolve(res.data);
      }
    });
  } catch (err) {
    console.log("请求失败", err);
  }
}

export async function post(url, params) {
  try {
    let res = await axios.post(url, params);
    return new Promise((resolve, reject) => {
      if (res.code === "SUCCESS") {
        resolve(res.data);
        Loading.service(true).close();
      } else {
        resolve(res.data);
      }
    });
  } catch (err) {
    // alert('请求失败了', err)
  }
}



// WEBPACK FOOTER //
// ./src/http/axios.js